import { render, staticRenderFns } from "./r-daily-quest-orders.vue?vue&type=template&id=71ab790a"
import script from "./r-daily-quest-orders.vue?vue&type=script&lang=js"
export * from "./r-daily-quest-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ab790a')) {
      api.createRecord('71ab790a', component.options)
    } else {
      api.reload('71ab790a', component.options)
    }
    module.hot.accept("./r-daily-quest-orders.vue?vue&type=template&id=71ab790a", function () {
      api.rerender('71ab790a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/daily-quest/r-daily-quest-orders.vue"
export default component.exports